import React, { FunctionComponent } from 'react';
import { LAYER_TYPE } from '@/utils/constants';
import {dispatchChooseBoxHandleClick} from "@/animations/responsive/productPageTracking";

interface Props {
    soldBy: string;
    newOffersCount: number;
    priceIncludeVAT: boolean;
    reconditionedOffersCount: number;
    cheapestPriceWithoutBestNewOffer: string;
    cheapestPriceWithoutBestNewOfferWithoutTax: string;
    cheapestPriceWithoutBestReconditionedOffer: string;
    cheapestPriceWithoutBestReconditionedOfferWithoutTax: string;
    handleClick: (layerType: string) => void;
    state?: string;
}

export const OfferTypeLabel: FunctionComponent<Props> = ({
    soldBy,
    priceIncludeVAT,
    newOffersCount,
    reconditionedOffersCount,
    cheapestPriceWithoutBestNewOffer,
    cheapestPriceWithoutBestReconditionedOffer,
    cheapestPriceWithoutBestReconditionedOfferWithoutTax,
    cheapestPriceWithoutBestNewOfferWithoutTax,
    handleClick,
    state
}) => {
    const isReconditioned = state !== 'new';
    const offerType = soldBy === 'BUT_MKP' ? 'Offre BUT' : 'Offre partenaire';
    const offerCount = (newOffersCount + reconditionedOffersCount) - 1;
    if (offerCount <= 0) {
        return null;
    }
    return (
        <>
            <div className='offer-type-label'>
                <div className='offer-type'>
                    <p>{offerType}</p>
                </div>
                <div
                    className='offer-details'
                    onClick={() => {
                        handleClick(LAYER_TYPE.CHOICE_BOX);
                        dispatchChooseBoxHandleClick()
                    }}
                >
                    <p className='count-offer'>
                        <span className='no-wrap'>
                            {` + ${offerCount} ${offerCount === 1 ? 'offre ' : 'offres '} `}
                        </span>
                        <span className='no-wrap'>
                            {` à partir de ${parseFloat(
                                !cheapestPriceWithoutBestReconditionedOffer || (cheapestPriceWithoutBestNewOffer && parseFloat(cheapestPriceWithoutBestNewOffer) < parseFloat(cheapestPriceWithoutBestReconditionedOffer)) ?
                                    priceIncludeVAT ? cheapestPriceWithoutBestNewOffer : cheapestPriceWithoutBestNewOfferWithoutTax :
                                    priceIncludeVAT ? cheapestPriceWithoutBestReconditionedOffer : cheapestPriceWithoutBestReconditionedOfferWithoutTax
                            ).toFixed(2).replace(".", ",")} €`}
                            {!priceIncludeVAT && <span className='price-ht'>&nbsp;HT</span>}
                        </span>
                    </p>

                    <img src={'/assets/images/responsive/icons/arrow.svg'} alt='flèche voir les offres' />
                </div>
            </div>
            {isReconditioned && <p className='reconditioned-label'>Reconditionné</p>}
        </>
    );
};

